import { styled } from "@mui/material/styles";

// Components
import { Card, Typography } from "@mui/material";
import { HashLoader } from "react-spinners";

// Images
import ActiveImage from "~/assets/images/activeAccount.png";

// Theme
import theme from "~/components/Common/Theme";

const styledName = "ActiveAccount";

export const StyledActiveBackground = styled("div", { name: styledName })({
  "&": {
    position: "relative",
    backgroundImage: `url(${ActiveImage})`,
    width: "100vw",
    height: "100vh",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
});

export const StyledLoading = styled(Card, { name: styledName })({
  "&": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: `translate(-50%,-50%)`,
    height: "300px",
    width: "580px",
    minWidth: "400px",
    borderRadius: "20px",
    backgroundColor: "#f5f5fa",
    opacity: "0.85",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
});

export const StyledLoadingHeader = styled(Typography, { name: styledName })({
  "&": {
    color: theme.palette.primary.main,
    fontSize: "2rem",
    fontFamily: "'Andika', sans-serif",
    height: "30px",
    marginTop: "30px",
  },
});

export const StyledLoadingDesc = styled(Typography, { name: styledName })({
  "&": {
    textAlign: "center",
    marginTop: "10px",
  },
});

export const StyledHashLoader = styled(HashLoader, { name: styledName })({
  "&": {
    margin: "30px 0",
  },
});

export const StyledErrorTitle = styled(StyledLoadingDesc, {
  name: styledName,
})({
  "&": {
    fontSize: "1.6rem",
    color: theme.palette.error.main,
  },
});

export const StyledErrorMessage = styled(StyledLoadingDesc, {
  name: styledName,
})({
  "&": {
    margin: "50px 0",
  },
});
